(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Decriminalization', Decriminalization);

    Decriminalization.$inject = ['$resource', 'DateUtils'];

    function Decriminalization ($resource, DateUtils) {
        var resourceUrl =  'api/decriminalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.updateDate = DateUtils.convertDateTimeFromServer(data.updateDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
